import {
  ResponseDataDC_Api_Base_SolutionOverview_SolutionOverviewModel,
  ResponseDataTaskDictionarySystem_StringSystem_Boolean,
} from '@monorepo-types/dc';

import { request } from '../client';
import type { ApiRequestConfig } from '../client/types';

type GetSolutionOverview = { dcOnly?: boolean };
/**
 * Retrieves the solutionoverview information. 
Add the controller after installing the nuget package by registering it in the program.cs file of the API project
 * 
 * @returns ResponseDataDC_Api_Base_SolutionOverview_SolutionOverviewModel Success
 */
export function getSolutionOverview(
  { dcOnly }: GetSolutionOverview,
  requestConfig: ApiRequestConfig = {},
): Promise<ResponseDataDC_Api_Base_SolutionOverview_SolutionOverviewModel> {
  return request(
    {
      method: 'GET',
      path: `/api/solutionoverview`,
      query: { dcOnly },
      errors: { 400: 'Bad Request' },
    },
    requestConfig,
  );
}

type FeatureToggleOverview = { dcOnly?: boolean };
/**
 * Returns all Toggles, from appsettings and Azure Featuremanagement
 *
 * @returns ResponseDataTaskDictionarySystem_StringSystem_Boolean Success
 */
export function featureToggleOverview(
  { dcOnly }: FeatureToggleOverview,
  requestConfig: ApiRequestConfig = {},
): Promise<ResponseDataTaskDictionarySystem_StringSystem_Boolean> {
  return request(
    {
      method: 'GET',
      path: `/api/featuretoggleoverview`,
      query: { dcOnly },
      errors: { 400: 'Bad Request' },
    },
    requestConfig,
  );
}

type GetGeneratedSwagger = { api?: string };
/**
 * Gets the generated swagger.
 *
 * @returns string Success
 */
export function getGeneratedSwagger(
  { api }: GetGeneratedSwagger,
  requestConfig: ApiRequestConfig = {},
): Promise<string> {
  return request(
    {
      method: 'GET',
      path: `/api/generatedswagger`,
      query: { api },
      errors: { 400: 'Bad Request' },
    },
    requestConfig,
  );
}
